var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"go-back",on:{"click":_vm.goBack}},[_c('button',[_c('v-icon',{attrs:{"dark":"","medium":""}},[_vm._v(" mdi-chevron-left ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }